var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragAndDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C3.10458 4 4 3.10458 4 2C4 0.895416 3.10458 0 2 0C0.895416 0 0 0.895416 0 2C0 3.10458 0.895416 4 2 4ZM10 2C10 3.10458 9.10458 4 8 4C6.89542 4 6 3.10458 6 2C6 0.895416 6.89542 0 8 0C9.10458 0 10 0.895416 10 2ZM2 10C3.10458 10 4 9.10458 4 8C4 6.89542 3.10458 6 2 6C0.895416 6 0 6.89542 0 8C0 9.10458 0.895416 10 2 10ZM10 8C10 9.10458 9.10458 10 8 10C6.89542 10 6 9.10458 6 8C6 6.89542 6.89542 6 8 6C9.10458 6 10 6.89542 10 8ZM4 14C4 15.1046 3.10458 16 2 16C0.895416 16 0 15.1046 0 14C0 12.8954 0.895416 12 2 12C3.10458 12 4 12.8954 4 14ZM8 16C9.10458 16 10 15.1046 10 14C10 12.8954 9.10458 12 8 12C6.89542 12 6 12.8954 6 14C6 15.1046 6.89542 16 8 16Z",
    fill: "#546A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragAndDrop);
export default __webpack_public_path__ + "static/media/drag-and-drop.96f3c0e024b074004334b48cace14136.svg";
export { ForwardRef as ReactComponent };